export const NEXT_BUTTON_CLICKED = 'draftLabelModel/NEXT_BUTTON_CLICKED';